import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useAuth0 } from '@auth0/auth0-react'
import { useEffect } from 'react'
import { EtainablSpinner } from '@/components/etainabl-spinner'

// Auth0 redirect target (authorizationParams.redirect_uri = `${origin}/callback`).
// The SDK consumes the ?code/state params; once it settles we bounce to the
// index route, which fans out to /admin or /tickets by role.
//
// MUST be SPA navigation: tokens are cached in memory, so a full page
// load here wipes the just-established session and loops back to login.
function Callback() {
  const { isLoading, isAuthenticated, error } = useAuth0()
  const navigate = useNavigate()

  useEffect(() => {
    if (isLoading) return
    // Either way leave /callback — errors fall back to the root guard, which
    // re-initiates login.
    if (isAuthenticated || error) navigate({ to: '/', replace: true })
  }, [isLoading, isAuthenticated, error, navigate])

  return (
    <div className="flex h-screen items-center justify-center">
      <EtainablSpinner size="lg" srLabel="Signing in" />
    </div>
  )
}

export const Route = createFileRoute('/callback')({ component: Callback })
